define(function (require) {
    "use strict";
    var CP_CONST = require("connection-const");
    var Loader = require("ui/loader/Loader");
    var SearchView = require("connection-views/SearchView");

    var TicketSearchController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketSearchController = Marionette.Controller.extend({

            referrerAction: CP_CONST.REFERER_ACTION.SEARCH_RESULTS_SNIPPET,

            initialize: function (options) {
                this.channel = options.channel || {vent:{}};
                this.ticketsCollection = options.ticketsCollection || {};
                this.context = options.connectionPanelContextModel || {};
                this._initViews();
                this._bindEvents();
            },

            _initViews: function () {
                this.searchView = new SearchView({placeholder: LE.translator.translate("LEConnection.cases.ticketTab.actionSearch.placeholder")});
                this.channel.vent.trigger("TicketTabController::showRegion:searchInputRegion", {view: this.searchView});
            },

            _bindEvents: function () {
                this.listenTo(this.searchView, SearchView.TRIGGERING.CHANGE, this._quickSearch, this);
                this.listenTo(this.searchView, SearchView.TRIGGERING.CLEAR_INPUT, this._onSearchCleared, this);
                this.listenTo(this.searchView, SearchView.TRIGGERING.INIT_SEARCH, this._onInitSearch);
                this.listenTo(this.context,"change:searchTerm",this._onSearchTermChanged);
                this.listenTo(this.searchView, "search:blur",this._onSearchBlur);
            },

            _quickSearch: function (options) {
                var searchTerm = (options) ? options.searchTerm : "";
                this._searchTroughCollection(searchTerm);
                this._setSearchTerm(searchTerm);
            },

            _onSearchCleared: function () {
                this._searchTroughCollection("");
                this._setSearchTerm("");
            },

            _onSearchBlur: function(){
                this._triggerUsageTracking();
            },

            _onInitSearch: function(){
                this._triggerUsageTracking();
            },

            _searchTroughCollection: function(value){
                this.ticketsCollection.filterBySummary(value);
            },

            _triggerUsageTracking: function(){
                this.channel.vent.trigger("TicketTabController::track:usage",{
                    slug:this._getSearchTerm(),
                    usageToTrack:CP_CONST.USAGE_TO_TRACK.MYCASES.SEARCH_CASES
                });
            },

            _setSearchTerm: function(value){
                this.context.set("searchTerm",value);
            },

            _getSearchTerm: function(){
                return this.context.get("searchTerm");
            },

            _onSearchTermChanged: function(){
                this.searchView.setValue(this._getSearchTerm());
            }
        });
    });
    return TicketSearchController;
});

